// src/components/UIBits.jsx
import React, { useState } from "react";
import { formatLocalDateTime, formatLocalTime, isoNoPunct } from "../helpers/utils";
import { googleCalendarLink, icsBlob } from "../helpers/calendar_utils";

export function KPI({ label, value }) {
  return (
    <div className="kpi">
      <div className="kpiLabel">{label}</div>
      <div className="kpiValue">{value}</div>
    </div>
  );
}

export function EscalateButton({ owner, text }) {
  const [sent, setSent] = useState(false);
  return (
    <button
      className={`btn ${sent ? "success" : ""}`}
      onClick={() => {
        setSent(true);
        console.log(`[Slack DM → @${owner}] ${text}`);
        setTimeout(() => setSent(false), 1800);
      }}
    >
      {sent ? "Sent ✓" : `DM ${owner}`}
    </button>
  );
}

export function SlotCard({ slot, durationMin, title, desc }) {
  const start = slot;
  const end = new Date(start.getTime() + durationMin * 60 * 1000);
  const gLink = googleCalendarLink({ title, desc, start, end });
  const ics = icsBlob({ title, desc, start, end });

  return (
    <div className="slot">
      <div>
        <div className="slotTitle">
          {formatLocalDateTime(start)} – {formatLocalTime(end)}
        </div>
        <div className="muted">{durationMin} minutes</div>
      </div>
      <div className="slotActions">
        <a className="btn primary" href={gLink} target="_blank" rel="noreferrer">
          Add to Google
        </a>
        <a className="btn" href={ics} download={`BossDrop-${isoNoPunct(start)}.ics`}>
          Download ICS
        </a>
      </div>
    </div>
  );
}
